import React, { useState, useEffect } from 'react'
import { Tabs } from 'antd';

import Layout from "../Layout/Layout";
import { url } from "../Constent/Constant";

const { TabPane } = Tabs;

const FormDatas = () => {
    const [QuotesData, setQuotesData] = useState('')
    const [ServiceInquiry, setServiceInquiry] = useState('')
    const [EstimationData, setEstimationData] = useState('')
    const [SubsData, setSubsData] = useState('')
    const [ContactData, setContactData] = useState('')

    useEffect(() => {
        fetch(`${url}/page/viewrequestaquote`)
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setQuotesData(data.doc)
            })

        fetch(`${url}/page/viewserviceinquiry`)
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setServiceInquiry(data.doc)
            })

        fetch(`${url}/page/viewgetfreeestimation`)
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setEstimationData(data.doc)
            })

            fetch(`${url}/page/viewsubscriber`)
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setSubsData(data.doc)
            })

            fetch(`${url}/page/viewcontactus`)
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setContactData(data.doc)
            })
    }, [])


    return (
        <Layout>
            <div className='FormD-container'>
                <Tabs defaultActiveKey="1" centered>
                    <TabPane className='Form-Tabs' tab="Quotes" key="1" >
                        {
                            QuotesData && QuotesData.map(data => (
                                <div className='Card'>
                                    <h1> Name : {`${data.firstname} ${data.lastname}`} </h1>
                                    <h1> Email : {data.email} </h1>
                                    <h1> Phone :  {data.phone} </h1>
                                </div>
                            ))
                        }
                         {
                            ContactData && ContactData.map(data => (
                                <div className='Card'>
                                    <h1> Name : {`${data.firstname} ${data.lastname}`} </h1>
                                    <h1> Email : {data.email} </h1>
                                    <h1> Phone :  {data.phone} </h1>
                                </div>
                            ))
                        }
                    </TabPane>

                    <TabPane className='Form-Tabs' tab="Service Inquiry" key="2">
                        {
                            ServiceInquiry && ServiceInquiry.map(data => (
                                <div className='Card'>
                                    <h1> Moving Type : {data.movingtype} </h1>
                                    <h1> From : {data.from} </h1>
                                    <h1> To : {data.to} </h1>
                                    <h1> Phone :  {data.phone} </h1>
                                </div>
                            ))
                        }
                    </TabPane>

                    <TabPane className='Form-Tabs' tab="Free Estimation" key="3">
                        {
                            EstimationData && EstimationData.map(data => (
                                <div className='Card'>
                                    <h1> Name : {`${data.firstname} ${data.lastname}`} </h1>
                                    <h1> Email : {data.email} </h1>
                                    <h1> Phone :  {data.phone} </h1>
                                    <h1> Address :  {data.address} </h1>
                                </div>
                            ))
                        }
                    </TabPane>
                    <TabPane className='Form-Tabs' tab="Emails" key="4">
                        {
                            SubsData && SubsData.map(data => (
                                <div className='Card'>
                                    <h1> Email : {data.email} </h1>
                                </div>
                            ))
                        }
                    </TabPane>
                </Tabs>
            </div>
        </Layout>
    )
}

export default FormDatas
